import React, { Component } from 'react';
import { number, string, func, oneOfType } from 'prop-types';

import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import CloseIcon from '@material-ui/icons/Close';

import styles from './styles.scss';

export default class UserInfoChip extends Component {
  static propTypes = {
    id: oneOfType([number, string]).isRequired,
    firstName: string,
    lastName: string,
    profileImage: string,
    onClick: func,
    onDelete: func,
    className: string
  }

  static defaultProps = {
    firstName: '',
    lastName: ''
  }

  //---------------------------------------------------------------------
  //------------------------Interaction Functions------------------------
  //---------------------------------------------------------------------
  handleClick = () => {
    const {id, onClick} = this.props;
    onClick && onClick(id);
  }

  handleDelete = () => {
    const {id, onDelete} = this.props;
    onDelete && onDelete(id);
  }
  //---------------------------------------------------------------------
  //---------------------------Draw Functions----------------------------
  //---------------------------------------------------------------------
  drawDeleteIcon = () => {
    return (
      <div className={styles.deleteIcon}>
        <CloseIcon fontSize="inherit" />
      </div>
    );
  }

  render() {
    const {
      firstName,
      lastName,
      profileImage,
      className,
      onClick,
      onDelete
    } = this.props;

    const firstInitial = firstName ? firstName.charAt(0) : '';
    const lastInitial = lastName ? lastName.charAt(0) : '';
    const initial = `${firstInitial}${lastInitial}`.toLocaleUpperCase();
    const avatar = (!profileImage || profileImage.length === 0) ? 
                      <Avatar>{initial}</Avatar> :
                      <Avatar alt={initial} src={profileImage} />; 

    const deleteIcon = this.drawDeleteIcon();

    return (
      <div className={className}>
        <Chip
          data-test="userInfoChip"
          avatar={avatar}
          label={`${firstName} ${lastName}`}
          onClick={onClick && this.handleClick}
          deleteIcon={deleteIcon}
          onDelete={onDelete && this.handleDelete}
        />
      </div>
    );
  }
}